<ng-template #ort>
  <ul class="p-0" id="detail_adresse">
    <li class="d-flex flex-column mb-1">
      <span class="fw-bold" id="details_adresse_label">Adresse</span>
      <span id="details_adresse">
        {{ termin.adresse?.strasse }}, {{ termin.adresse?.plz }}
        {{ termin.adresse?.ort }}
      </span>
    </li>
    @if (termin.adresse?.hinweise; as hinweise) {
      <li class="d-flex flex-column mb-1">
        <span class="fw-bold" id="details_adresse_hinweise_label">Hinweis zur Adresse</span>
        <span [innerHTML]="sanitizeFunction(hinweise)" id="details_adresse_hinweise"> </span>
      </li>
    }
  </ul>
  <div>
    <now-wbsuche-lib-geois-map
      [blurWithMessage]="blurWithMessage()"
      [city]="termin.adresse?.ort"
      [street]="termin.adresse?.strasse"
      [title]="'Veranstaltungsort'"
      [zipCode]="termin.adresse?.plz"
      [controlsDisabled]="collapsed"
    ></now-wbsuche-lib-geois-map>
  </div>
</ng-template>
<ng-template #ortsunabhaengig>
  <div class="d-flex align-items-center">
    <img
      alt="Dieses Angebot findet ortsunabhängig statt."
      class="logo-ortsunabhaengig d-print-none"
      ngSrc="./assets/images/ortsunabhaengig.png"
      width="143"
      height="91"
    />
    <div class="align-self-center">
      Dieses Angebot findet ortsunabhängig statt. Nähere Informationen können dem Angebot entnommen
      werden oder kontaktieren Sie den Anbieter.
    </div>
  </div>
</ng-template>
<ng-container *ngTemplateOutlet="termin.adresse ? ort : ortsunabhaengig"></ng-container>
